// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3Sivx","inner":"Footer_inner__2vDSH"};